// extracted by mini-css-extract-plugin
export default {"body":"styles_body__QMg8I","timeline":"styles_timeline__wlA0s","dot":"styles_dot__rTPje","listPosition":"styles_listPosition__H0j--","listItem":"styles_listItem__FCOKr"};